'use client';

import React, { useEffect } from 'react';

interface ToastMessageProps {
  type: 'success' | 'error';
  message: string;
  onClose: () => void;
  duration?: number; // in milliseconds
}

const ToastMessage: React.FC<ToastMessageProps> = ({ type, message, onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="fixed top-5 left-1/2 transform -translate-x-1/2 z-50">
      <div
        className={`px-4 py-3 rounded shadow-lg text-white flex items-center space-x-2
          ${type === 'success' ? 'bg-green-500' : 'bg-red-500'}`}
      >
        <span>{type === 'success' ? '✅' : '⚠️'}</span>
        <span>{message}</span>
      </div>
    </div>
  );
};

export default ToastMessage;
